import React, { useState, useEffect ,useRef} from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
// import { login, verifyOtp, forgotPassword, resetPassword, loadUserFromToken, reSentOtp } from './../../../services/global_redux/globale_actions/Login.action';
import { vendorLogin ,vendorForgotPassword} from "../../../services/audit_redux/audit_actions/vendor.action"
// import './Login.css';
import $ from "jquery"
import dashboardImg from '../../../assets/global_assets/login_imgs/dashboard.PNG';
import Logo from '../../../assets/global_assets/login_imgs/logo.png';
import Lock from '../../../assets/global_assets/login_imgs/lock_icon.png';
import Sms from '../../../assets/global_assets/login_imgs/sms_icon.png';
import lock_open_icon from '../../../assets/global_assets/login_imgs/lock_open_icon.png';
function VendorLogin({ setIsLoggedIn },props) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [vendorId, setVendorId] = useState('');
    const [vendorIdNewPass, setVendorIdNewPass] = useState('');
    const [vendorPassword, setVendorPassword] = useState('');
    const [error, setError] = useState('');
    const [passResendMsg, setPassResendMsg] = useState('');
    const [stage, setStage] = useState('login');
    const [isFormValid, setIsFormValid] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            try {
                const decodedToken = jwtDecode(token);
                if (decodedToken.exp > Date.now() / 1000) {
                    // dispatch(loadUserFromToken());
                    setIsLoggedIn(true);
                    window.location.href = '/dashboard';
                } else {
                    localStorage.removeItem('token');
                    sessionStorage.removeItem('token');
                    sessionStorage.removeItem('dashboardAlertShown');
                    sessionStorage.removeItem('selectedClient');
                    navigate('/login');
                }
            } catch (error) {
                localStorage.removeItem('token');
                sessionStorage.removeItem('token');
                sessionStorage.removeItem('dashboardAlertShown');
                sessionStorage.removeItem('selectedClient');
                navigate('/login');
            }
        }
    }, [dispatch, navigate, setIsLoggedIn]);

    useEffect(() => {
        setShowPassword(false);
        switch (stage) {
            case 'login':
                setIsFormValid(vendorId !== '' && vendorPassword !== '');
                break;
            case 'forgotPassword':
                setIsFormValid(vendorIdNewPass !== '');
                setPassResendMsg('');
                break;
            default:
                setIsFormValid(false);
        }

    }, [vendorId, vendorPassword, vendorIdNewPass, stage]);

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');
        setIsSubmitting(true)
        if(!vendorId || !vendorPassword){
            setError('Please enter valid Vendor id and password');
            setIsSubmitting(false)
        }else{
            const userData = { vendor_id :vendorId,password: vendorPassword };
            try {
                const response = await dispatch(vendorLogin(userData));
                if (response.success) {
                    window.location.reload();                   
                } else {
                    setIsSubmitting(false)
                    setError(response.message);
                    setPassResendMsg('');
                    setStage('login');
                }
            } catch (error) {
                setIsSubmitting(false)
                setError(error.message || 'Please enter valid Vendor id and password');
                setPassResendMsg('');
                setStage('login');
            }
        }
    };

    const handleForgotPassword = async (e) => {
        e.preventDefault();
        setIsSubmitting(true)
        if(!isFormValid){
            setError('Please enter the valid mail');
        }else{
            try {
                const data = {
                    vendor_id:vendorIdNewPass
                }
                const response = await dispatch(vendorForgotPassword(data));
                if (response.success) {
                    setIsSubmitting(false)
                    setError('');
                    setStage('login');
                    setPassResendMsg(response.message);
                    setVendorIdNewPass('');
                } else {
                    setIsSubmitting(false)
                    setStage('forgotPassword');
                    setError(response.message ||'Please enter the valid vendor id');
                    setPassResendMsg('');
                }
            } catch (error) {
                setIsSubmitting(false)
                setStage('forgotPassword');
                setError(error.message || 'Please enter the vendor id');
                setPassResendMsg('');
            }
        }
    };

    const handleStageChange = (newStage) => {
        setStage(newStage);
        if(newStage === 'forgotPassword'){
            setVendorPassword('');
            setVendorId('');
        }
        if(newStage === 'login'){
            setVendorIdNewPass('');
        }
        setError('');
    };

    return (
        <div className="container-body loginMainContainer m-0 p-0">
          <div className="col-md-12 m-0 mainpagee">
            <div className="row p-0 m-0 d-flex justify-content-center ">
              <div className="col-md-7  p-0 loginDashboardPage">
                <div className="row p-0 m-0 mainrowlogin">
                    <div className="col-md-11  p-0 m-0 loginLeft loginLeftExtra">
                    <div className="imgAnim1"></div>
                <div className="imgAnim2"></div>
                <div className="row loginlftText">
                  <div className="ms-0">
                  <h1 className="text-white m-0 textSize1 PoppinsLogin dashboardcontentpadding">Simplify & Manage</h1>
                  <h4 className="text-white m-0 textSize1 PoppinsLogin dashboardcontentpadding">Compliance In-House</h4>
                  <p className="text-muted1 textSize4 text-light-login1 mt-2">Handle complex compliance processes with ease—<br/> AccunityHR makes it simple, scalable, and self-managed.
                  </p>
                  </div>
                  <div className="loginDashboard col-md-12 ">
                    <img src={dashboardImg} alt="Dashboard" className="loginDashboardImg " />
                  </div>
                </div>
                    </div>
                </div>
              </div>
      
              <div className="col-md-5 p-0 h-100 ">
                <div className="col-md-12  d-flex align-items-center justify-content-center paddingandmarginLogin">
                <div className="row loginformmailrow">
                    <div className="col-md-11">
                    <div className="row">
                    <div className="loginForm  w-100">
      
                    <div className="row justify-content-center">
                    <div className="col-md-12">
                  <div className=" mb-4 mt-2">
                    <img src={Logo} alt="Logo"  className="loginlogoImg" />
                  </div>
                    <h5 className=" font-weight-bolder1  m-0 p-0 textSize1 PoppinsLogin mt-3">Stay Compliant, Stay Ahead</h5>
                    <p className="text-muted textSize4 text-light-login mt-2 pt-1 mb-3 pb-2">Your trusted partner for efficient and automated compliance processes</p>
                    
                    {passResendMsg && <p className='textSize4 text-success'><b>{passResendMsg}</b></p>}
                    {stage === 'login' && (
                        <form onSubmit={handleLogin}>
                            <div class="form-group">
                                <label for="usermail" className='textSize3 PoppinsLogin pb-1'><b>Vendor ID</b></label>
                                <div className="mb-3 position-relative">
                                    <input
                                    type="text"
                                    className="form-control textSizeinputlogin PoppinsLogin textSize4"
                                    placeholder="Vendor ID"
                                    name="vendorId"
                                    value={vendorId}
                                    onChange={(e) => setVendorId(e.target.value)}
                                    id="usermail"
                                    disabled={isSubmitting}
                                    />
                                    <img
                                    src={Sms}
                                    alt="user icon"
                                    className="position-absolute "
                                    style={{
                                        right: '15px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        height: '20px',
                                        width: '20px',
                                    }}
                                    />
                                </div>
                            </div>
                        <div class="form-group">
                            <label for="password" className='textSize3 PoppinsLogin pb-1'><b>Password</b></label>
                            <div className="mb-3 position-relative">
                                <input
                                type={showPassword ? "text" : "password"}
                                className="form-control textSizeinputlogin textSize4 PoppinsLogin"
                                placeholder="Password"
                                id="password"
                                name="vendorPassword"
                                value={vendorPassword}
                                onChange={(e) => setVendorPassword(e.target.value)}
                                disabled={isSubmitting}
                                />
                                <img
                                src={showPassword ? lock_open_icon : Lock}
                                alt="lock icon"
                                className="position-absolute"
                                onClick={() => setShowPassword(!showPassword)}
                                style={{
                                    right: '15px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    height: '20px',
                                    width: '20px',
                                    cursor: 'pointer'
                                }}
                                />
                            </div>
                        </div>
                            {/* {error && <span className="text-danger textSize4">{error}</span>} */}
                            {error && <span className="text-danger textSize4" style={{ color: 'red' }}>
                                <div className="error-message">
                                    <i className="bi bi-exclamation-circle-fill me-0"></i>
                                    {error}
                                </div>
                                </span>}
                            <div className="mb-3">
                            {/* <a href="#" className="text-primary textSize3 PoppinsLogin" onClick={() => handleStageChange('forgotPassword')} disabled ={stage === "login"}>Forgot Password?</a> */}
                            <a
                                href="#"
                                className={`loginforgotpasswordcolor textSize3 PoppinsLoginlight ${stage !== 'login' ? 'disabled-link-login' : ''}`}
                                onClick={(e) => {
                                    if (stage === 'login') {
                                        handleStageChange('forgotPassword');
                                    return;
                                    }
                                }}
                                >
                                Forgot Password?
                            </a>

                        </div>
                        <button type="submit" className="btn loginbtnprimary w-100 py-2 PoppinsLogin" disabled={isSubmitting} ><b className='textSize3' >Login</b></button>
                            
                        </form>
                    )}
                    {stage === 'forgotPassword' && (
                        <form onSubmit={handleForgotPassword}>
                            {/* <p>Enter your user email to generate and reset password</p> */}
                            <div class="form-group">
                            <label for="vendorIdNewPass"  className='textSize3 PoppinsLogin pb-1'><b>Vendor ID</b></label>
                            <div className="mb-3 position-relative">
                                <input
                                type="text"
                                className="form-control textSizeinputlogin PoppinsLogin"
                                placeholder="Vendor ID"
                                name="vendorIdNewPass" value={vendorIdNewPass} onChange={(e) => setVendorIdNewPass(e.target.value)}
                                id="vendorIdNewPass"
                                />
                                <img
                                src={Sms}
                                alt="user icon"
                                className="position-absolute "
                                style={{
                                    right: '15px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    height: '20px',
                                    width: '20px',
                                }}
                                disabled={isSubmitting}
                                />
                            </div>
                        </div>
                            {/* {error && <span className="text-danger textSize4 PoppinsLogin" style={{ color: 'red' }}>{error}</span>} */}
                            {error && <span className="text-danger textSize4" style={{ color: 'red' }}>
                                <div className="error-message">
                                    <i className="bi bi-exclamation-circle-fill me-0"></i>
                                    {error}
                                </div>
                                </span>}
                            
                        <button type="submit" className="btn loginbtnprimary w-100 py-2 PoppinsLogin" disabled={isSubmitting}><b className='textSize3' >Submit</b></button>
                        <div className="mt-3 text-center textSize4 RalewayLogin">
                            <a href="#" className="text-primary fw-bold"  onClick={() => handleStageChange('login')}>Login ?</a>
                        </div> 
                        </form>
                    )}
                    </div>
                    </div>

                    
                </div>
                </div>
                    </div>
                </div>
                </div>
                            
                <div className=" plicydivlogin text-center text-muted small d-flex justify-content-between PoppinsLoginlight textSize5" >
                    <span>Privacy Policy</span> <span>Copyright 2025</span>
                  </div>
              </div>
            </div>
          </div>
        </div>
      );
      
}

export default VendorLogin;
